import React from 'react';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

type Props = Omit<SvgIconProps, 'viewBox'>;

export function ProjectsIcon(props: Props) {
    const newProps = {
        width: 24,
        height: 24,
        fill: 'none',
        'aria-hidden': true,
        ...props,
        viewBox: '0 0 24 24',
    };
    return React.createElement(
        SvgIcon,
        newProps,
        <path
            d="M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    );
}
